import { supabaseClient } from '@auth-v2';
import { useMutation } from '@tanstack/react-query';

import { keyParameterUpdate } from '@data';
import { activeUserIdAtom, useEnsureAtomValue } from '@store';

import { queryClient } from '../config';
import { queryKeys } from '../queryKeys';

export const useKeyParameterUpdate = (layoutId: number) => {
    const activeUserId = useEnsureAtomValue(activeUserIdAtom);
    return useMutation({
        mutationFn: (keyParameterId: string) => keyParameterUpdate(supabaseClient, { layoutId, keyParameterId }),
        onSuccess: (layout) => {
            queryClient.invalidateQueries({
                queryKey: queryKeys.layout.user(activeUserId),
            });
            queryClient.invalidateQueries({
                queryKey: queryKeys.layout.all(activeUserId),
            });

            queryClient.invalidateQueries({
                queryKey: queryKeys.layout.default(activeUserId),
            });
            if (!layout) return;
            queryClient.invalidateQueries({
                queryKey: queryKeys.layoutCustomization.base(activeUserId, layout!.id),
                exact: false,
            });
        },
    });
};
